/* 陸遜傳・第 4 章：襄陽・種豆弈棋（嘉禾三年，234）
 * 史實：《陸遜傳》「權北征。使遜與諸葛瑾攻襄陽。遜遣親人韓扁賚表奉報，還。遇敵於沔中，鈔邏得扁。瑾聞之甚懼。……
 *       遜未答，方催人種葑豆，與諸將欒棋射戲如常。……遜曰：『……今便示退，賊當謂吾怖，仍來相蹙，必敗之勢也。』
 *       乃密與瑾立計，令瑾督舟船，遜悉上兵馬，以向襄陽城。敵素憚遜，遽還赴城。瑾便引船出，遜徐整部伍，張拓聲勢，步趨船，敵不敢干。」
 *       年份：〈陸遜傳〉作嘉禾五年，〈吳主傳〉繫於嘉禾三年（孫權圍合肥新城、退還），取三年。
 * 流程：1. 如常：軍心慢慢往下掉（兵將意動）；催種葑豆、與諸將下棋、射戲把軍心拉回來。走出營太遠就是「示退」，魏軍立刻來追（戰敗）。
 *       2. 悉上兵馬，以向襄陽城：帶全軍往襄陽推，魏兵看到陸遜就退回城裡。
 *       3. 徐整部伍，步趨船：轉身走回江邊上船。隊伍散開「聲勢」就掉，低了魏騎出城來咬；掉光戰敗。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, vanish } from '../kit.ts';
import { MEN, WEI, WU, band, drawPlot, drawBoard, drawTarget, drawShip } from './luxun_kit.ts';
import { CAMP, DOCK, CITY, GATE, NEAR, PLOTS, BOARD, TARGET, RANGE } from '../maps/luxun_xiangyang.ts';

const LV = 18, CALM_T = 75, DRAIN = 1.6, OUT_R = 1300, OUT_T = 4, SPREAD = 380;
const WEIB = { spec: WEI, name: '魏兵', hp: 560, maxHp: 560, atk: 30 };
const FUN = { board: [3, 15, 18, '弈棋'], range: [2, 10, 14, '射戲'] }; // 讀條秒數、軍心、多久能再來一次、名稱

export default {
  id: 'luxun-4', map: 'luxun_xiangyang', hero: 'luxun',
  title: '第 4 章　襄陽・種豆弈棋', year: '嘉禾三年（234）',
  brief: {
    quote: [{ text: '方催人種葑豆，與諸將欒棋射戲如常。', src: '《三國志·吳書·陸遜傳》' }],
    text: '孫權北征合肥新城，陸遜與諸葛瑾攻襄陽。孫權已經退兵，陸遜派回去報信的親信韓扁又在沔水被魏軍抓走，行軍虛實全洩漏了。諸葛瑾寫信來：「宜當急去。」陸遜沒有回信。（〈陸遜傳〉作嘉禾五年，〈吳主傳〉在嘉禾三年。）',
    goals: ['如常：種葑豆、下棋、射戲，穩住軍心；不要示退', '悉上兵馬，以向襄陽城', '徐整部伍，張拓聲勢，步趨船'],
  },
  words: { ally: '吳兵', foe: '魏兵' },
  stars: [
    { text: '軍心沒有低於五成', ok: (m) => m.vars.calmMin >= 50 },
    { text: '聲勢沒有低於六成', ok: (m) => m.vars.shMin >= 60 },
    { text: '一個兵都沒有折損', ok: (m) => m.stats.lost === 0 },
  ],
  steps: [
    { // 0. 如常
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = CAMP[0] + 100; me.y = CAMP[1] + 200;
        V.calm = 70; V.calmMin = 70; V.sh = 100; V.shMin = 100; V.outT = 0; V.t0 = w.t; V.cd = { board: 0, range: 0 };
        V.men = Array.from({ length: 12 }, (_, i) => { const u = m.recruit(CAMP[0] - 400 + (i % 6) * 110, CAMP[1] + 420 + Math.floor(i / 6) * 90, '吳兵'); u.home = [u.x, u.y]; u.hp = u.maxHp = 650; u.atk = 26; return u; });
        V.plots = PLOTS.map(([x, y], i) => { const f = m.folk(x, y, { still: true, near: 1, name: '', n: 0, draw: drawPlot }); f.i = i; return f; });
        V.board = m.folk(BOARD[0], BOARD[1], { still: true, near: 1, name: '', draw: drawBoard });
        m.folk(TARGET[0], TARGET[1], { still: true, near: 1, name: '', draw: drawTarget });
        V.ships = [[DOCK[0] - 300, DOCK[1] + 420], [DOCK[0] + 50, DOCK[1] + 460], [DOCK[0] + 400, DOCK[1] + 420]].map(([x, y]) => { const f = m.folk(x, y, { still: true, near: 1, name: '', draw: drawShip }); f.x = x; f.y = y; return f; });
        // 魏軍斥候：在營外遠遠地繞
        V.scouts = [[CAMP[0] + 1500, CAMP[1] - 600], [CAMP[0] - 1500, CAMP[1] - 500], [CAMP[0] + 1200, CAMP[1] + 900]].map(([x, y], i) => {
          const u = m.foe('huangjin', x, y, Object.assign({}, WEIB, { name: '魏斥候', hp: 400, maxHp: 400, ms: 230 })); m.patrol(u, [[x, y], [x + (i % 2 ? 500 : -500), y + 300]]); return u;
        });
        m.card('權北征。使遜與諸葛瑾攻襄陽。遜遣親人韓扁賚表奉報，還。遇敵於沔中，鈔邏得扁。', '《陸遜傳》');
        m.after(7, () => m.card('瑾聞之甚懼。書與遜云：「大駕已旋，賊得韓扁，具知吾闊狹。且水干，宜當急去。」', '《陸遜傳》'));
        m.after(14, () => m.line('陸遜', '……來人，催他們把葑豆種下去。'));
        m.after(18, () => m.line('提示', '軍心會慢慢往下掉。種葑豆、和諸將下棋、射戲都能穩住軍心。魏軍的斥候在看：走出營太遠，就像要逃。'));
        m.after(40, () => { V.zj = ally(w, MEN.zhugejin, DOCK[0] + 200, DOCK[1] - 200, LV - 4); V.zj.name = '諸葛瑾'; V.zj.hold = [CAMP[0] - 250, CAMP[1] + 150]; m.line('諸葛瑾', '伯言多智略，其當有以。我自己去見他。'); });
        m.after(52, () => m.line('陸遜', '賊知大駕已旋，無所復戚，得專力於吾。又已守要害之處，兵將意動，且當自定以安之，施設變術，然後出耳。'));
        m.after(58, () => m.line('陸遜', '今便示退，賊當謂吾怖，仍來相蹙，必敗之勢也。'));
        m.obj('calm', '');
        m.obj('wait', '');
        PLOTS.forEach(([x, y], i) => m.mark('p' + i, x, y, '葑豆', true));
        m.mark('board', BOARD[0], BOARD[1], '棋', true);
        m.mark('range', RANGE[0], RANGE[1], '射', true);
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, t = w.t - V.t0;
        V.calm -= DRAIN * dt;
        for (const f of V.plots) if (!f.done) m.chanAt(me, 'p' + f.i, f.x, f.y, 170, 2, '催種葑豆', () => { f.done = true; f.n = 1; V.calm += 15; m.unmark('p' + f.i); m.line('兵士', '將軍還有心思種豆，看來沒事。'); }, { hurt: false });
        for (const k of ['board', 'range']) {
          V.cd[k] -= dt;
          const [ct, gain, again, label] = FUN[k], [x, y] = k === 'board' ? BOARD : RANGE;
          if (V.cd[k] <= 0) m.chanAt(me, k, x, y, 160, ct, label, () => { V.calm += gain; V.cd[k] = again; m.line('諸將', k === 'board' ? '大都督這一手……妙！' : '好箭！'); }, { hurt: false });
        }
        V.calm = Math.min(100, V.calm); V.calmMin = Math.min(V.calmMin, V.calm);
        m.get('calm').text = `軍心：${Math.max(0, Math.round(V.calm))}%`;
        m.get('wait').text = `如常（還要 ${Math.max(0, Math.ceil(CALM_T - t))} 秒）`;
        // 示退：走出營太遠（往江邊的船走更是）
        const out = SG.gd(me.x, me.y, CAMP[0], CAMP[1]) > OUT_R || me.x < CAMP[0] - 1000;
        if (out) { if (V.outT === 0) { m.big('魏軍斥候盯著你！'); m.line('諸將', '大都督要走了？'); } V.outT += dt; } else V.outT = 0;
        if (V.outT > OUT_T) { m.lose('今便示退，賊當謂吾怖，仍來相蹙'); return false; }
        if (V.calm <= 0) { m.lose('兵將意動，軍心潰散'); return false; }
        return t >= CALM_T;
      },
    },
    { // 1. 悉上兵馬，以向襄陽城
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('wait'); m.drop('calm');
        for (const k of ['p0', 'p1', 'p2', 'board', 'range']) m.unmark(k);
        m.card('乃密與瑾立計，令瑾督舟船，遜悉上兵馬，以向襄陽城。', '《陸遜傳》');
        if (V.zj) { V.zj.hold = DOCK.slice(); m.line('諸葛瑾', '船交給我。'); m.after(10, () => vanish(w, V.zj)); }
        for (const u of V.men) if (u.alive) m.join(u, me);
        // 城外的魏軍
        V.wei = [];
        for (let i = 0; i < 12; i++) { const u = m.foe('huangjin', 5200 + (i % 4) * 380, 1900 + Math.floor(i / 4) * 300, WEIB); u.home = [u.x, u.y]; V.wei.push(u); }
        V.wei = V.wei.concat(m.alive(V.scouts));
        for (const u of V.scouts) u.patrol = null;
        m.mark('near', NEAR[0], NEAR[1], '襄陽城下');
        m.obj('xy', '悉上兵馬，以向襄陽城');
        m.after(3, () => m.line('陸遜', '全軍出營，向襄陽！'));
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        for (const u of V.wei) if (u.alive && !u.back && SG.gd(u.x, u.y, me.x, me.y) < 800) {
          u.back = true; u.untargetable = true; u.target = null; u.patrol = null; u.ms = 300; u.home = [CITY.x + (SG.rand() - 0.5) * 600, CITY.y + (SG.rand() - 0.5) * 400];
          if (!V.backSaid) { V.backSaid = true; m.line('魏將', '是陸遜親來！快回城！'); }
        }
        for (const u of V.wei) if (u.back) { u.target = null; u.think = 0.5; }
        return SG.gd(me.x, me.y, NEAR[0], NEAR[1]) < 300;
      },
    },
    { // 2. 徐整部伍，張拓聲勢，步趨船
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('xy'); m.unmark('near');
        // 還在城外的魏兵也逃進城
        for (const u of V.wei) if (u.alive) { u.untargetable = true; u.back = true; u.x = CITY.x + (SG.rand() - 0.5) * 600; u.y = CITY.y + (SG.rand() - 0.5) * 300; u.home = [u.x, u.y]; }
        m.gate('gate', GATE[0], GATE[1], 150, 'citygate');
        m.card('敵素憚遜，遽還赴城。瑾便引船出。', '《陸遜傳》');
        m.after(4, () => m.line('陸遜', '整好部伍，慢慢走回船上。不要跑，不要散。'));
        m.after(8, () => m.line('提示', '兵是步卒，走得比你慢。跑在前面、兵掉在後面，聲勢就掉；聲勢低了魏騎就會出城來咬。'));
        for (const u of V.men) if (u.alive) { u.ms = u.ms0 = 200; }
        // 出城跟著的魏騎：遠遠吊著
        m.after(10, () => {
          m.ungate('gate');
          V.cav = Array.from({ length: 6 }, (_, i) => m.foe('huangjin', GATE[0] - 100 + (i % 3) * 90, GATE[1] + 120 + Math.floor(i / 3) * 80, Object.assign({}, WEIB, { name: '魏騎', ms: 260, hp: 600, maxHp: 600, atk: 34 })));
          m.gate('gate', GATE[0], GATE[1], 150, 'citygate');
          m.line('魏將', '吳軍要走了……跟上去看看。');
        });
        m.mark('dock', DOCK[0], DOCK[1], '上船');
        m.obj('dock', '徐整部伍，步趨船');
        m.obj('sh', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, men = m.alive(V.men);
        const far = men.filter((u) => SG.gd(u.x, u.y, me.x, me.y) > SPREAD).length;
        V.sh = Math.max(0, Math.min(100, V.sh + (far ? (-15 * far / men.length - 2) * dt : 4 * dt))); // 掉隊越多掉越快
        V.shMin = Math.min(V.shMin, V.sh);
        m.get('sh').text = `聲勢：${Math.round(V.sh)}%${far ? `（${far} 人掉隊）` : ''}`;
        // 魏騎：聲勢夠就只遠遠吊著；聲勢低了就衝上來咬
        if (V.cav) for (const u of V.cav) {
          if (!u.alive) continue;
          if (V.sh >= 50) { u.target = null; u.think = 0.5; const a = Math.atan2(GATE[1] - me.y, GATE[0] - me.x); u.home = [me.x + Math.cos(a) * 800, me.y + Math.sin(a) * 600]; }
          else { u.home = [me.x, me.y]; if (!V.biteSaid) { V.biteSaid = true; m.line('魏將', '吳軍亂了！追！'); } }
        }
        if (V.sh >= 50) V.biteSaid = false;
        if (V.sh <= 0) { m.lose('部伍散亂，敵乘之'); return false; }
        return SG.gd(me.x, me.y, DOCK[0], DOCK[1]) < 250 && men.every((u) => SG.gd(u.x, u.y, DOCK[0], DOCK[1]) < 600);
      },
    },
    { // 3. 敵不敢干
      enter(m, w) {
        const V = m.vars;
        m.done('dock'); m.unmark('dock'); m.drop('sh');
        if (V.cav) for (const u of V.cav) if (u.alive) { u.home = [GATE[0], GATE[1] + 200]; u.target = null; }
        m.card('遜徐整部伍，張拓聲勢，步趨船，敵不敢干。', '《陸遜傳》');
        m.after(7, () => m.card('軍到白圍，託言住獵，潛遣將軍周峻、張梁等擊江夏新市、安陸、石陽……斬首獲生，凡千餘人。其所生得，皆加營護，不令兵士干擾侵侮。', '《陸遜傳》'));
        m.after(15, () => m.card('臣松之以為……俘馘千人，未足損魏，徒使無辜之民橫罹荼酷。', '裴注（裴松之案語）'));
        m.after(22, () => m.card('赤烏七年，遜代顧雍為丞相。二宮之爭，遜上疏「書三四上」；權累遣中使責讓遜，遜憤恚致卒，時年六十三。家無餘財。', '《陸遜傳》'));
        m.after(30, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const me = w.player, V = m.vars;
    if (!me.alive) { m.lose('陸遜陣亡'); return; }
    if (V.zj && V.zj.alive) allyTick(w, V.zj, null, 0);
    // 斥候只看不打
    if (m.i === 0 && V.scouts) for (const u of V.scouts) if (u.alive) { u.target = null; u.think = 0.5; }
  },
};
